export const ENABLE_PH_REC = true;
export const ENABLE_MERIE_REPORTS = true;

// colors
export type Riskiness = 'LOW' | 'MEDIUM' | 'HIGH';
export type RiskinessColors = Record<Riskiness, {background: string; hexDarker: string} | undefined>;
export const RISKINESS_COLORS: RiskinessColors = {
  LOW: {background: 'var(--dlRiskLow)', hexDarker: '#A7F0BA'},
  MEDIUM: {background: 'var(--dlRiskMedium)', hexDarker: '#FDDC69'},
  HIGH: {background: 'var(--dlRiskHigh)', hexDarker: '#FFB3B8'},
};
